import { ICombo, IComboSlotSelections, IItem } from '@rbi-ctg/menu';
import { IModifierSelectionAction } from 'utils/wizard';

const SODIUM_LIMIT = 2300;

interface IComputeSodiumArgs {
  selectedOpt: ICombo | IItem;
  comboSlotSelections: IComboSlotSelections | undefined;
  modifierSelections: IModifierSelectionAction[] | undefined;
}

export function computeSodium({ selectedOpt, comboSlotSelections }: IComputeSodiumArgs): number {
  let sodium = 0;

  if (selectedOpt._type === 'item') {
    sodium += selectedOpt?.nutritionWithModifiers?.sodium || 0;
  }

  //sodium for selected option mainItem
  if (selectedOpt._type === 'combo' && selectedOpt.mainItem) {
    sodium += selectedOpt?.mainItem?.nutritionWithModifiers?.sodium || 0;
  }

  //sodium for each combo slot selection
  if (comboSlotSelections) {
    Object.values(comboSlotSelections).forEach(selection => {
      selection.selections.forEach(choice => {
        sodium +=
          (choice.option?.option?.nutritionWithModifiers?.sodium || 0) * (choice.quantity || 1);
      });
    });
  }

  return sodium;
}

export function hasExcessSodium(args: IComputeSodiumArgs): boolean {
  const totalSodium = computeSodium(args);
  return isOverSodiumLimit(totalSodium);
}

export function isOverSodiumLimit(value: number): boolean {
  return value > SODIUM_LIMIT;
}
